import { render, staticRenderFns } from "./abilityList.vue?vue&type=template&id=bf2b7a00&scoped=true"
import script from "./abilityList.vue?vue&type=script&lang=js"
export * from "./abilityList.vue?vue&type=script&lang=js"
import style0 from "./abilityList.vue?vue&type=style&index=0&id=bf2b7a00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2b7a00",
  null
  
)

export default component.exports